import { ReactComponent as CallIcon } from './svg/call.svg'

export default CallIcon
